import axios from 'axios';
import { env } from '@config/env';
import { useAuthStore } from '../stores/authStore';
import { installInterceptors } from './interceptors';
import { navigateTo } from '@shared/lib/navigation';

/**
 * Tenant (regional) API client. Base URL is dynamic — the regional edge
 * is determined by Core `/resolve-domain` and stored in authStore. We rebind
 * the baseURL on every request via the request interceptor below so that
 * tenant switches take effect immediately without rebuilding the instance.
 */
export const tenantApi = axios.create({
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
});

tenantApi.interceptors.request.use((config) => {
  const regional = useAuthStore.getState().regionalApiUrl;
  config.baseURL = regional || env.apiBaseUrl;
  return config;
});

installInterceptors(tenantApi, {
  refresh: async (refreshToken) => {
    const baseURL = useAuthStore.getState().regionalApiUrl || env.apiBaseUrl;
    const { data } = await axios.post(
      `${baseURL}/auth/refresh`,
      { refresh_token: refreshToken },
      { headers: { 'Content-Type': 'application/json' } },
    );
    return {
      accessToken: data.accessToken ?? data.access_token,
      refreshToken: data.refreshToken ?? data.refresh_token,
    };
  },
  onRefreshFailed: () => {
    void useAuthStore.getState().signOut();
    navigateTo('/login', { replace: true });
  },
});
